export default function useKeepAlive() {
  const route = useRoute()
  const cachedSet = ref<Set<string>>(new Set())

  const cachedViews = computed(() => Array.from(cachedSet.value))

  watch(() => route.name, (routeName) => {
    if (route.meta.keepAlive && routeName) {
      cachedSet.value.add(routeName as string)
    }
  }, { immediate: true })

  return {
    cachedViews,
  }
}
